import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Row, Col, Spinner, Accordion, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import Graph from '@components/AvalancheMonitor/GraphView/Graph';
import { AVA_DASHBOARD_TAB_KEY, STATE_STATUS, AVA_DASHBOARD_DOUGHNUT_TYPES } from '@awp/constants';
import { fetchDashboardViews } from '@stores/avalancheDashboardViewPageSlice';
import CardHeaderToggle from '@components/Common/Accordion/CardHeaderToggle';

const AvalancheVisualContainer = ({ id }) => {
  const [tabKey, setTabKey] = useState(AVA_DASHBOARD_TAB_KEY.VISUAL);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDashboardViews());
  }, []);

  return (
    <Accordion defaultActiveKey="0">
      <Card border="light" className="page-card">
        <CardHeaderToggle eventKey="0" as="h4" title={'Overview'} />
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            <Row>
              <Col>{/* <GraphActions graphId={id} /> */}</Col>
            </Row>
            <Tabs
              id="graph-tabs"
              activeKey={tabKey}
              onSelect={(k) => setTabKey(k)}
              className="mb-3 tab"
              transition={false}
            >
              <Tab eventKey={AVA_DASHBOARD_TAB_KEY.VISUAL} title="Visual"></Tab>
              {/* <Tab eventKey={AVA_DASHBOARD_TAB_KEY.TEXT} title="Text"></Tab> */}
            </Tabs>
            <div className="graph__container">
              <Row style={{ justifyContent: 'center' }}>
                <Col lg={4} md={4}>
                  <Graph
                    graphId={`visual-container-quality`}
                    presentation={tabKey}
                    insideText={'Ingestion rate'}
                    dashboardType={AVA_DASHBOARD_DOUGHNUT_TYPES.QUALITY}
                  />
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

AvalancheVisualContainer.propTypes = {
  id: PropTypes.any.isRequired,
};

export default AvalancheVisualContainer;
